import { Link } from "react-router-dom";
import React from "react";
import { TrendingUp } from "lucide-react";

export default function Logo({ isExpanded }) {
  return (
    <Link to="/" className="flex items-center">
      <span className="flex items-center font-bold text-lg text-white tracking-wider">
        {isExpanded ? (
          <div className="flex items-center space-x-2.5">
            <div className="w-7 h-7 rounded-lg bg-blue-600/20 border border-blue-500/40 flex items-center justify-center shrink-0 shadow-sm shadow-blue-900/30">
              <TrendingUp className="h-4 w-4 text-blue-400" />
            </div>
            <span className="text-base font-black tracking-widest text-white font-sans">
              GODS<span className="text-blue-400">EYE</span>
            </span>
          </div>
        ) : (
          <div className="w-7 h-7 rounded-lg bg-blue-600/20 border border-blue-500/40 flex items-center justify-center shrink-0 shadow-sm shadow-blue-900/30">
            <TrendingUp className="h-4 w-4 text-blue-400" />
          </div>
        )}
      </span>
    </Link>
  );
}
